import {
  BrowserUpdated,
  OpenInNew,
  AutoAwesome,
  Calculate,
  Campaign,
} from '@mui/icons-material';
import BrandingIcon from '@mui/icons-material/Brush';
import Agreements from '@mui/icons-material/HistoryEdu';
import Search from '@mui/icons-material/ManageSearch';
import UserManagement from '@mui/icons-material/PeopleOutline';
import { useAuthContext } from '../../contexts/AuthContext';
import { useGenerateCostCalculatorToken } from '../../hooks/api/useGenerateCostCalculatorToken';
import { useApi } from '../../hooks/api/useApi';
import { SidebarItemsType } from '../../types/sidebar';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import JournalIntelligence from '@mui/icons-material/Insights';
import Statistics from '@mui/icons-material/BarChart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { env } from '../../env';
import { ONBOARDING_APP_URL } from '../../constants';

const searchUrl = env.PUBLIC_SEARCH_URL;

const DashboardItems = () => {
  const { account, loggedInAccount } = useAuthContext();
  const { mutate: generateToken } = useGenerateCostCalculatorToken();
  const { downloadFile } = useApi();

  const handleOpenCalculator = () => {
    // Open synchronously so Safari's popup blocker allows it, then redirect once token arrives
    const newWindow = window.open('', '_blank');
    generateToken(undefined, {
      onSuccess: (data) => {
        if (newWindow) {
          newWindow.location.href = `${searchUrl}/ta-cost-calculator?token=${data.token}`;
        }
      },
      onError: () => {
        newWindow?.close();
      },
    });
  };

  const handleDownloadJournals = () => {
    const date = new Date().toISOString().split('T')[0];
    downloadFile('/export', `journals_${date}.tsv`);
  };

  const pagesSection = [
    {
      children: [
        loggedInAccount === 'admin'
          ? {
              href: '/accounts',
              title: 'Accounts',
              icon: AccountCircleIcon,
            }
          : null,
        loggedInAccount === 'admin' && account === 'admin'
          ? {
              href: '/master-list',
              title: 'Master List',
              icon: ListAltIcon,
            }
          : null,
        loggedInAccount === 'admin'
          ? {
              href: '/journal-intelligence',
              title: 'Journal Intelligence',
              icon: JournalIntelligence,
            }
          : null,
        loggedInAccount === 'admin'
          ? {
              href: '/announcements',
              title: "What's New",
              icon: Campaign,
            }
          : null,
        {
          href: '/agreements',
          title: 'Agreements',
          icon: Agreements,
        },
        {
          href: '/internal-search',
          title: 'Internal Search',
          icon: Search,
        },
        {
          href: '/statistics',
          title: 'Statistics',
          icon: Statistics,
        },
        {
          href: '/admin-management',
          title: 'Admin Management',
          icon: UserManagement,
        },
        {
          href: '/branding',
          title: 'Branding',
          icon: BrandingIcon,
        },
        {
          onAction: handleOpenCalculator,
          title: 'TA Cost Calculator',
          icon: Calculate,
        },
        {
          href: `${searchUrl}/${account}`,
          title: 'Public Search',
          icon: OpenInNew,
        },
        {
          onAction: handleDownloadJournals,
          title: 'Download Journals',
          icon: BrowserUpdated,
          eventCode: 'download_journals',
        },
        loggedInAccount === 'admin' && account === 'admin'
          ? {
              href: ONBOARDING_APP_URL,
              title: 'Onboarding Generator',
              icon: AutoAwesome,
              target: '_blank',
            }
          : null,
      ].filter(Boolean),
    },
  ] as SidebarItemsType[];

  return pagesSection;
};

export default DashboardItems;
